<h2>
    Vehicle Results ({{results.length}})
    <button class="icon--add btn--default" type="button" *ngIf="false === readonly" data-bs-toggle="modal" data-bs-target="#myModal" (click)="onAddVehicle()">Add New Vehicle</button>
</h2>

<p-table [value]="results" styleClass="search--vehicle" #dataTable *ngIf="displayResults" [rows]="10" [paginator]="true"
         [globalFilterFields]="['vin', 'vehicleId', 'vehicleTypeDisplayValue','makeDisplayValue', 'modelDisplayValue','bodyStyleTypeDisplayValue','modelYear','plateNumber','registrationEndDate']">
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dataTable.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="9 + (hideSelect ? 0: 1)">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th [pSortableColumn]="'vin'" class="w--vin">VIN<p-sortIcon [field]="'vin'"></p-sortIcon></th>
            <th [pSortableColumn]="'vehicleId'">Vehicle Id<p-sortIcon [field]="'vehicleId'"></p-sortIcon></th>
            <th [pSortableColumn]="'vehicleTypeDisplayValue'">Vehicle Type<p-sortIcon [field]="'vehicleTypeDisplayValue'"></p-sortIcon></th>
            <th [pSortableColumn]="'makeDisplayValue'">Make<p-sortIcon [field]="'makeDisplayValue'"></p-sortIcon></th>
            <th [pSortableColumn]="'modelDisplayValue'">Model<p-sortIcon [field]="'modelDisplayValue'"></p-sortIcon></th>
            <th [pSortableColumn]="'bodyStyleTypeDisplayValue'">Body Style<p-sortIcon [field]="'bodyStyleTypeDisplayValue'"></p-sortIcon></th>
            <th [pSortableColumn]="'modelYear'" class="w--icon">Year<p-sortIcon [field]="'modelYear'"></p-sortIcon></th>
            <th [pSortableColumn]="'plateNumber'">Plate #<p-sortIcon [field]="'plateNumber'"></p-sortIcon></th>
            <th [pSortableColumn]="'registrationEndDate'">Reg End Date<p-sortIcon [field]="'registrationEndDate'"></p-sortIcon></th>
            <th class="w--icon" [hidden]="hideSelect">Select</th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td>
                <a href="javascript:void(0)" (click)="onSelect(data)" *ngIf="hideSelect">{{data.vin}}</a>
                <ng-container *ngIf="!hideSelect">{{data.vin}}</ng-container>
            </td>
            <td>{{data.vehicleId}}</td>
            <td>{{data.vehicleTypeDisplayValue}}</td>
            <td class="td--hover-show">{{data.makeDisplayValue}}</td>
            <td>{{data.modelDisplayValue}}</td>
            <td class="td--hover-show">{{data.bodyStyleTypeDisplayValue}}</td>
            <td>{{data.modelYear}}</td>
            <td>{{data.plateNumber}}</td>
            <td> {{getRegistrationEndDateFormatted(data)}}</td>
            <td class="text-center" [hidden]="hideSelect">
                <a class="icon--select" href="javascript:void(0)" title="Select" (click)="onSelect(data)"></a>
            </td>
        </tr>
    </ng-template>
</p-table>
